/**
 * Indicate if the given date is past.
 */
export const isPastDate = (date: Date | string): boolean => {
  return new Date(date).getTime() - new Date().getTime() < 0
}
